import { API_VERSION, HOME_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_HOMES = `${HOME_SERVICE}/pricing`;

export const pricing = {
  plans: {
    getById: async ({ id }) => {
      const options = await apiOptions({
        url: `${API_HOMES}/plans/${id}`,
        method: "get",
        headers: { [X_API_VERSION]: API_VERSION },
      });
      return apiRequest(options);
    },
  },
  options: {
    getById: async ({ planId, optionId }) => {
      const options = await apiOptions({
        url: `${HOME_SERVICE}/pricing/plans/${planId}/options/${optionId}`,
        method: "get",
        headers: { [X_API_VERSION]: API_VERSION },
      });
      return apiRequest(options);
    },
    getAll: async ({ planId }) => {
      const options = await apiOptions({
        url: `${HOME_SERVICE}/pricing/plans/${planId}/options`,
        method: "get",
        headers: { [X_API_VERSION]: API_VERSION },
      });
      return apiRequest(options);
    },
  },
};
